import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const BASE_API = process.env.VUE_APP_BASE_API_URL;

class CategoryService {
    list() {
        return axios.get(BASE_API + 'category', { headers: authHeader() });
    }
    create(data) {
        return axios.post(BASE_API + 'category', data, { headers: authHeader() });
    }
    update(id, data) {
        return axios.patch(BASE_API + 'category/'+id, data, { headers: authHeader() });
    }
    delete(id) {
        return axios.delete(BASE_API + 'category/'+id, "", { headers: authHeader() });
    }

}

export default new CategoryService();
